import React from 'react';
import { Translate } from 'react-localize-redux';
import CustomTooltip from "../../common/customTooltip";
import PropTypes from 'prop-types';

class NacesRow extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        naces: PropTypes.array,
    };

    static defaultProps = {
        title: "Report.CompanyIdentification.PrimaryNace",
        naces: undefined,
    };

    render = () => {
        const { title, naces } = this.props;

        return (naces && naces.length > 0) ? (
            <div className='ident-item'>
                <span><Translate id={title} /></span>
                <span>
                    {naces.map((n, i) =>
                        <React.Fragment key={i}>
                            <div style={{ width: '70%', display: 'inline-block' }}>
                                <span className="id-name" style={{ display: "flex" }}>
                                    <span>
                                        {n.value}
                                    </span>
                                </span>
                            </div>
                            <div style={{ width: '30%', display: 'inline-block' }}>
                                <span className="src" id={"nacesFullSource" + i} style={{ whiteSpace: "nowrap", alignSelf: "flex-end", float: 'right' }}>
                                    {n.source}
                                    <CustomTooltip textAlign="right" placement='left' id={"nacesFullSource" + i} text={n.SourceFull} hideIcon delay={{ "show": 0, "hide": 0 }} innerClassName='tooltipSection'>
                                    </CustomTooltip>
                                </span>
                            </div>
                        </React.Fragment>

                    )}
                </span>
            </div>) : null;
    }
}

export default NacesRow;